import React from 'react';
export const TextBlock: React.FC<{
  children: React.ReactNode;
  className?: string;
}> = ({
  children,
  className = ''
}) => <div className={`max-w-[680px] mx-auto px-5 sm:px-6 text-[1.0625rem] sm:text-[1.1875rem] leading-[1.75] sm:leading-[1.8] text-navy/90 font-serif space-y-5 sm:space-y-6 ${className}`} data-id="element-204">
    {children}
  </div>;
export const ArticleH2: React.FC<{
  children: React.ReactNode;
  className?: string;
}> = ({
  children,
  className = ''
}) => <h2 className={`text-2xl sm:text-3xl font-bold mt-10 sm:mt-14 mb-5 sm:mb-6 text-navy font-serif leading-tight ${className}`} data-id="element-205">
    {children}
  </h2>;
export const ArticleImage: React.FC<{
  src: string;
  alt: string;
  aspect?: string;
  className?: string;
  caption?: string;
}> = ({
  src,
  alt,
  aspect = 'aspect-video',
  className = '',
  caption
}) => <figure className={`my-8 sm:my-12 ${className}`} data-id="element-206">
    <img src={src} alt={alt} className={`w-full object-cover rounded-sm ${aspect}`} data-id="element-207" />
    {caption && <figcaption className="text-center text-sm text-navy/60 mt-3 font-sans" data-id="element-208">
        {caption}
      </figcaption>}
  </figure>;